<template>
	<div class="history">
		<nav-bar navBarTitle="浏览历史"></nav-bar>
		<div class="history-content">
			<van-list
				v-model="loading"
				:finished="finished"
				@load="onLoad"
				:finished-text="finishedText"
			>
				<div class="history-content-item" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
					<div class="history-content-item-l">
						<h2>{{ item.businessName }}</h2>
						<!-- <p class="apply-time">申报时间：
							<span v-if="item.startDate || item.endDate">{{ item.startDate }}{{ item.endDate ? '～' : '' }}{{item.endDate }}</span>
							<span v-else>待定</span>
						</p> -->
						<div class="time">
							<template>
								<!--<span v-if="item.createTime ? new Date().getTime() - new Date(item.createTime.replace(/\./g, '/')).getTime() < 86400000:false">今天 {{ item.createTime.substr(11,5) }}</span>-->
								<!--<span v-else-if="item.createTime ? 86400000<= new Date().getTime() - new Date(item.createTime.replace(/\./g, '/')).getTime() < 172800000: false">昨天 {{ item.createTime.substr(11,5) }}</span>-->
								<!--<span v-else>{{ item.createTime ? item.createTime : ''  }}</span>-->
								<span>{{  item.createTime | createTimeStr}}</span>
							</template>
							<img src="../../assets/img/member/view_logo.png" />
							<span>浏览{{ item.times || 0}}次</span>
						</div>
					</div>
					<div class="history-content-item-r">
						<span class="icon iconfont iconfanhui2"></span>
					</div>
					<img class="close" src="../../assets/img/member/close.png"  v-if="isEdit" @click.stop="showTip(item.recordId)" />
				</div>
			</van-list>
		</div>
		<list-operate v-if="dataList.length" @handleEdit="editList" @handleDone="doneList" @handleClear="clearList"></list-operate>
		<!--没有数据-->
		<no-data v-if="!dataList.length" :type="1"></no-data>
		<system-confirm text="确认删除？" :show.sync="deleteShow" @handleConfirm="deleteData" @handleCancel="handleCancel"></system-confirm>
	</div>
</template>

<script>
	import ListOperate from '../../components/ListOperate'
	import SystemConfirm from '../../components/SystemConfirm'
	import NoData from '../../components/NoData'
	import { isEmpty } from '../../utils';
	import { reqClearRecord, reqDeleteRecord, reqRecordList } from '../../api';
	import Toast from 'vant/es/toast';
	import moment from 'moment'

	export default {
		name: 'history',
		components: {
			ListOperate,
			SystemConfirm,
			NoData
		},
		data() {
			return {
				dataList: [],
				total: 0, // 总条数
				loading: false,
				finished: false,
				isEdit: false, // 是否是编辑状态
				deleteShow: false,  // 删除提示框
				deleteIndex: null,
				times:0,  // 浏览次数
				size: 10, // 分页大小 d
				page: 1, // 当前页
				businessType: 1, // 政策
				operateType: 1, // 操作类型2：浏览1
			}
		},
		computed: {
			finishedText: {
				get(){
					return this.total>0 && this.finished === true ? '没有更多了' : ''
				},
				set(){
				}
			},
		},
		watch:{
			dataList(newList) {
				if(newList.length){
					this.dataList = newList
				}
			}
		},
		filters: {
			createTimeStr: function (time) {
				let str = time.replace(/\./g, '/')
				let today = moment();
				let yesterday = moment().subtract(1, 'day');
				if(moment(str).isSame(today, 'day')){
					return   `今天 ${time.substr(11,5)}`
				} else if(moment(str).isSame(yesterday, 'day')){
					return   `昨天 ${time.substr(11,5)}`
				} else {
					return `${time.substr(0,10)}`
				}
			}
		},
		created() {
			this.getDataList()
		},
		methods: {
			// 列表加载
			onLoad() {
				this.page++
				this.getDataList()
			},
			// 删除提示
			showTip(recordId){
				if(!isEmpty(recordId)){
					this.deleteShow = true
					this.deleteIndex = recordId
				}
			},
			// 取消操作
			handleCancel() {
				if(isEmpty(this.deleteIndex)){
					this.deleteIndex = null
				}
			},
			// 获取我的收藏列表数据
			getDataList() {
				this.loading = true
				let params = {
					page: this.page,
					size: this.size,
					operateType: this.operateType,
					businessType: this.businessType
				}
				reqRecordList(params).then(res => {
					// 加载状态结束
					this.loading = false;
					this.total = res.total
					let list  = res.data || []
					this.dataList = this.dataList.concat(list)
					if (this.dataList.length >= this.total) {
						this.finished = true;
					}
				})
			},
			// 编辑
			editList(){
				this.isEdit = true
			},
			// 完成
			doneList(){
				this.isEdit = false
			},
			// 清空
			clearList(){
				let params = {
					operateType: this.operateType
				}
				reqClearRecord(params).then(()=>{
					this.refresh()
				})
			},
			// 删除某条数据
			deleteData(){
				// 删除数据提示
				let params = {
					recordId: this.deleteIndex ,
				}
				reqDeleteRecord(params).then(() => {
					Toast('删除成功')
					this.deleteIndex = null
					setTimeout(()=>{
						this.refresh()
					},1000)
				})
			},
			// 跳转详情
			goDetail(item) {
				// eslint-disable-next-line
				sensors.track('policyClick', {
					policy_id: item.businessId,
					policy_name: item.businessName,
					policy_show_type: "非模糊",
					match_level: '',
					policy_department: '',
					max_declare: ''
				})
				this.$router.push({
					path: '/detail',
					query: {
						policyId: item.businessId
					}
				})
			},
			// 刷新
			refresh(){
				this.page = 1
				this.total =  0
				this.dataList = []
				this.loading =  false
				this.finished  = false
				this.isEdit = false
				this.getDataList()
			}
		}
	};
</script>

<style lang="less" scoped>
	.history {
		padding: 0 16px;
		&-content{
			width: 100%;
			margin-top: 16px;
			margin-bottom: 110px;
			&-item {
				width: 100%;
				// height: 135px;
				padding: 16px;
				display: flex;
				justify-content: center;
				align-items: center;
				box-shadow:0px 0px 20px 0px rgba(0,0,0,0.05);
				border-radius:5px;
				position: relative;
				margin-bottom: 16px;
				&-l {
					flex:1;
					display: flex;
					flex-direction: column;
					justify-content: center;
					h2 {
						font-weight: bold;
						line-height: 22px;
					}
					.apply-time  {
						margin-top: 16px;
						font-size:12px;
						font-weight:400;
						color:@subBlue;
						line-height:12px;
						/*> span  {*/
							/*margin-left: 8px;*/
						/*}*/
					}
					.time {
						margin-top: 14px;
						font-size:12px;
						line-height: 17px;
						color: @subBlack;
						display: flex;
						align-items: center;
						> img {
							width: 12px;
							height: 8px;
							margin-left: 10px;
						}
					}
				}
				&-r {
					color: @lightBlack;
				}
			}
		}
		.close {
			position: absolute;
			top: 0;
			right: 0;
			width: 24px;
			height: auto;
		}
	}

</style>
